import { create } from 'zustand'

export interface Message {
  id: string
  room_id: string
  sender_id: string
  username: string
  display_name?: string
  avatar_url?: string
  text: string
  type: 'text' | 'image' | 'file'
  reply_to?: string
  created_at: number
  status: 'sent' | 'delivered' | 'read'
  effect?: string
}

export interface Conversation {
  id: string
  title?: string
  name?: string
  type: 'dm' | 'group'
  last_msg?: string
  last_msg_time?: number
  unread: number
  members?: Array<{ uid: string; username: string; avatar_url?: string }>
}

interface ChatState {
  conversations: Conversation[]
  activeConversation: Conversation | null
  messages: Record<string, Message[]>
  loading: boolean
  setConversations: (convos: Conversation[]) => void
  setActiveConversation: (convo: Conversation | null) => void
  addMessage: (roomId: string, msg: Message) => void
  setMessages: (roomId: string, msgs: Message[]) => void
}

export const useChatStore = create<ChatState>((set) => ({
  conversations: [],
  activeConversation: null,
  messages: {},
  loading: false,

  setConversations: (convos) => set({ conversations: convos, loading: false }),
  setActiveConversation: (convo) => set({ activeConversation: convo }),
  addMessage: (roomId, msg) =>
    set((state) => ({
      messages: {
        ...state.messages,
        [roomId]: [...(state.messages[roomId] || []), msg],
      },
    })),
  setMessages: (roomId, msgs) =>
    set((state) => ({
      messages: { ...state.messages, [roomId]: msgs },
    })),
}))
